// src/components/DMCA.js
import styled from "styled-components";
import { Link } from "react-router-dom";

const DMCA = () => {
  return (
    <Wrap>
      <Inner>
        <Top>
          <H1>DMCA Copyright Policy</H1>
          <Meta>
            Catching Gold Diggers
            <Dot>•</Dot>
            Last updated: <strong>[2026]</strong>
          </Meta>

          <Intro>
            Catching Gold Diggers respects the intellectual property rights of others. This page explains how to submit a copyright
            infringement notice (takedown request)
          </Intro>
        </Top>

        <Section id="takedown">
          <H2>1. Submitting a DMCA Takedown Notice</H2>
          <P>
            If you believe that content available on the Site infringes your copyright, send a
            written notice with the information listed below to our Designated Agent.
          </P>

          <Callout>
            <CalloutTitle>Designated Agent</CalloutTitle>
            <CalloutText>
              Email: <strong>[dmca@catchinggolddiggers.com]</strong>
              <br />
              Subject line: <strong>DMCA Takedown Notice</strong>
            </CalloutText>
          </Callout>

          <P>Your notice must include:</P>
          <List>
            <li>
              Your full legal name and contact information (email address, phone number, and postal
              address).
            </li>
            <li>
              Identification of the copyrighted work claimed to have been infringed (or a
              representative list if multiple works are covered by one notice).
            </li>
            <li>
              The exact URL(s) on Catching Gold Diggers where the allegedly infringing material
              appears, plus enough detail for us to locate it.
            </li>
            <li>
              A statement that you have a good faith belief that the disputed use is not authorised
              by the copyright owner, its agent, or the law.
            </li>
            <li>
              A statement that the information in the notice is accurate, and under penalty of
              perjury, that you are the copyright owner or authorised to act on the owner’s behalf.
            </li>
            <li>Your physical or electronic signature.</li>
          </List>

          <P>
            We may request additional information if needed to process your request. If you submit
            incomplete or inaccurate information, we may be unable to act.
          </P>
        </Section>

    
        <Section id="other-issues">
          <H2>2. Other Complaints or Reporting Content</H2>
          <P>
            DMCA requests are for copyright issues only. If your request relates to non consensual
            content, privacy, illegal content, or if you are depicted in a video and want removal,
            please use our reporting channel instead.
          </P>
          <P>
            Report content email: <strong>[report@catchinggolddiggers.com]</strong>
          </P>
          <P>
            You can also review the reporting process in our{" "}
            <StyledLink to="/terms#report-content">Terms</StyledLink>.
          </P>
        </Section>

        <BottomNav>
          <BackLink to="/">Back to Home</BackLink>
        </BottomNav>
      </Inner>
    </Wrap>
  );
};

export default DMCA;

/* ---------- styles ---------- */

const Wrap = styled.div`
  background: #000;
  color: #fff;
  min-height: 100vh;
  padding: 60px 0;
`;

const Inner = styled.div`
  max-width: 980px;
  margin: 0 auto;
  padding: 0 80px;

  @media (max-width: 868px) {
    padding: 0 35px;
  }

  @media (max-width: 568px) {
    padding: 0 20px;
  }
`;

const Top = styled.div`
  margin-bottom: 26px;
`;

const H1 = styled.h1`
  margin: 0 0 10px;
  font-size: 36px;
  font-weight: 900;
  letter-spacing: -0.4px;

  @media (max-width: 568px) {
    font-size: 28px;
  }
`;

const Meta = styled.div`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.65);
`;

const Dot = styled.span`
  margin: 0 10px;
  color: rgba(255, 255, 255, 0.35);
`;

const Intro = styled.p`
  margin: 14px 0 0;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.78);
`;

const Section = styled.section`
  scroll-margin-top: 110px;
  margin-top: 26px;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
`;

const H2 = styled.h2`
  margin: 0 0 10px;
  font-size: 18px;
  font-weight: 800;
`;

const P = styled.p`
  margin: 0 0 10px;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.78);
`;

const List = styled.ul`
  margin: 0 0 10px;
  padding-left: 18px;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.65;

  li {
    margin: 6px 0;
  }
`;

const Callout = styled.div`
  margin: 14px 0 12px;
  padding: 14px 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
`;

const CalloutTitle = styled.div`
  font-size: 13px;
  font-weight: 800;
  margin-bottom: 6px;
  color: rgba(255, 255, 255, 0.92);
`;

const CalloutText = styled.div`
  font-size: 13px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.78);
`;

const BottomNav = styled.div`
  margin-top: 34px;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  justify-content: flex-start;
`;

const StyledLink = styled(Link)`
  color: rgba(255, 255, 255, 0.92);
  text-decoration: underline;
`;

const BackLink = styled(Link)`
  color: rgba(255, 255, 255, 0.92);
  text-decoration: none;
  font-weight: 700;

  &:hover {
    text-decoration: underline;
  }
`;
